import { useQuery } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GET_EXERCISE_WITH_DISCIPLINES_AND_SERIES } from '../queries/exercisesWithDisciplinesAndSeries';
import { ExerciseOutput } from '../gql/graphql';

export const useGetExercisesWithDisciplinesAndSeries = () => {
  return useQuery<ExerciseOutput[], Error>({
    queryKey: ['exercisesWithDisciplinesAndSeries'],
    queryFn: async () => {
      const data = await graphqlFetch<
        {
          exercisesWithDisciplinesAndSeries: ExerciseOutput[];
        },
        null
      >(GET_EXERCISE_WITH_DISCIPLINES_AND_SERIES);
      return data.exercisesWithDisciplinesAndSeries;
    },
  });
};
